import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '@wke/ucc-icons';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@wke/ucc-icons';
var alertCardEnum;
(function (alertCardEnum) {
    /** alert-card de tipo error. */
    alertCardEnum["error"] = "error";
    /** alert-card de tipo información. */
    alertCardEnum["info"] = "info";
    /** alert-card de tipo aviso. */
    alertCardEnum["warning"] = "warning";
})(alertCardEnum || (alertCardEnum = {}));

/**
 * Este componente genera un card de alerta, mostrando un icono y una descripción al lado.
 * Se puede configurar el tipo de mensaje que se va a mostrar, entre info, waring, o error
 *
 * @example
 *  <ucc-alert-card
 *      [cardType]="type"
 *      [message]="message">
 *  </ucc-alert-card>
 *
 */
class AlertCardComponent {
    constructor() {
        /** Tipo de alert card que se va a mostrar. */
        this.cardType = alertCardEnum.info;
        /** Mensaje que el alert card va a mostrar. */
        this.message = '';
        this.icon = '';
        this.className = '';
        this.iconKeys = {
            error: { icon: 'exclamation-circle', className: 'card-alert-error' },
            info: { icon: 'checkIcon', className: 'card-alert-info' },
            warning: { icon: 'warningTriangleIcon', className: 'card-alert-warning' }
        };
    }
    ngOnInit() {
        this.icon = this.iconKeys[this.cardType].icon;
        this.className = this.iconKeys[this.cardType].className;
    }
}
AlertCardComponent.ɵfac = function AlertCardComponent_Factory(t) { return new (t || AlertCardComponent)(); };
AlertCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AlertCardComponent, selectors: [["ucc-alert-card"]], inputs: { cardType: "cardType", message: "message" }, decls: 6, vars: 5, consts: [[1, "card-alert-icon", "colAuto", "alignMiddle"], ["iconClass", "componentIcon", 1, "loginPageErrorIcon", 3, "key"], [1, "card-alert-detail", "colAvailable", "alignVerticalMiddle"], [2, "color", "#373737"]], template: function AlertCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelement(2, "ucc-icon", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMapInterpolate1("card-alert horizontalLayout ", ctx.className, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("key", ctx.icon);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.message);
    } }, directives: [ɵngcc1.IconComponent], styles: ["[_nghost-%COMP%]     .card-alert{height:60px;background-color:#ededed;border:1px solid;margin-bottom:10px}[_nghost-%COMP%]     .card-alert.card-alert-error{border-color:#e72b39}[_nghost-%COMP%]     .card-alert.card-alert-error .card-alert-icon{background-color:#e72b39}[_nghost-%COMP%]     .card-alert.card-alert-info{border-color:#69c862}[_nghost-%COMP%]     .card-alert.card-alert-info .card-alert-icon{background-color:#69c862}[_nghost-%COMP%]     .card-alert.card-alert-warning{border-color:#ffa853}[_nghost-%COMP%]     .card-alert.card-alert-warning .card-alert-icon{background-color:#ffa853}[_nghost-%COMP%]     .card-alert .card-alert-icon{width:50px}[_nghost-%COMP%]     .card-alert .card-alert-icon i{color:#fff;font-size:22px}[_nghost-%COMP%]     .card-alert .card-alert-detail{padding:0 20px;font-size:14px}"] });
AlertCardComponent.propDecorators = {
    cardType: [{ type: Input }],
    message: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertCardComponent, [{
        type: Component,
        args: [{
                selector: 'ucc-alert-card',
                template: "<div class=\"card-alert horizontalLayout {{className}}\">\r\n    <div class=\"card-alert-icon colAuto alignMiddle\">\r\n        <ucc-icon key='{{icon}}'\r\n                  class=\"loginPageErrorIcon\"\r\n                  iconClass=\"componentIcon\"></ucc-icon>\r\n    </div>\r\n    <div class=\"card-alert-detail colAvailable alignVerticalMiddle\">\r\n        <span style=\"color: #373737\">{{ message }}</span>\r\n    </div>\r\n</div>",
                styles: [":host ::ng-deep .card-alert{height:60px;background-color:#ededed;border:1px solid;margin-bottom:10px}:host ::ng-deep .card-alert.card-alert-error{border-color:#e72b39}:host ::ng-deep .card-alert.card-alert-error .card-alert-icon{background-color:#e72b39}:host ::ng-deep .card-alert.card-alert-info{border-color:#69c862}:host ::ng-deep .card-alert.card-alert-info .card-alert-icon{background-color:#69c862}:host ::ng-deep .card-alert.card-alert-warning{border-color:#ffa853}:host ::ng-deep .card-alert.card-alert-warning .card-alert-icon{background-color:#ffa853}:host ::ng-deep .card-alert .card-alert-icon{width:50px}:host ::ng-deep .card-alert .card-alert-icon i{color:#fff;font-size:22px}:host ::ng-deep .card-alert .card-alert-detail{padding:0 20px;font-size:14px}\n"]
            }]
    }], function () { return []; }, { cardType: [{
            type: Input
        }], message: [{
            type: Input
        }] }); })();

class AlertCardModule {
}
AlertCardModule.ɵfac = function AlertCardModule_Factory(t) { return new (t || AlertCardModule)(); };
AlertCardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AlertCardModule });
AlertCardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            IconModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AlertCardModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    IconModule
                ],
                exports: [
                    AlertCardComponent
                ],
                declarations: [
                    AlertCardComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AlertCardModule, { declarations: function () { return [AlertCardComponent]; }, imports: function () { return [CommonModule,
        IconModule]; }, exports: function () { return [AlertCardComponent]; } }); })();

class UccDrawingModule {
}
UccDrawingModule.ɵfac = function UccDrawingModule_Factory(t) { return new (t || UccDrawingModule)(); };
UccDrawingModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UccDrawingModule });
UccDrawingModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            AlertCardModule
        ], AlertCardModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UccDrawingModule, [{
        type: NgModule,
        args: [{
                imports: [
                    AlertCardModule
                ],
                exports: [
                    AlertCardModule
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UccDrawingModule, { imports: [AlertCardModule], exports: [AlertCardModule] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AlertCardComponent, AlertCardModule, UccDrawingModule, alertCardEnum };

